var BaseViews = require('../base');
var MenuItemPricesLocationTable = require('./common/menu-item-prices-location-table');
var MenuItemPrices = require('./common/menu-item-prices');

var AvailableAtLocations = require('./common/available-at-locations');
var VideosGroup = require('../video-group');
var ThumbnailSelector = require('./menu-item-expanded/thumbnail-selector.js');
var PhotoSwiper = require('./menu-item-expanded/photo-swiper.js');
var PotencyDisplay = require('./common/potency-display');
var FavouriteButton = require('./common/favourite-button');

require('./menu-item-expanded/menu-item-expanded.scss');
var UIUtils = require('../../utils/ui');

var MenuItemExpanded = BaseViews.LayoutView.extend({
    _menuItemPrices: null,
    _DISPLAY_PRODUCT_TAG_FOR_CATEGORIES: ['hash', 'cbd'],
    className: 'fmcy-menu-item-expanded',
    template: require('./menu-item-expanded/menu-item-expanded.html'),
    ui: {
        btnClose: '.fmcy-menu-item-btn-close',
        imageSml: '.fmcy-menu-image',
        itemImage: '.fmcy-menu-item-thumb-image',
        strainAttribute: '.fmcy-item-strain-attribute',
        ratingAttribute: '.fmcy-item-rating-attribute',
        imageMagnifyIdicator: '.fmcy-menu-item-icon-magnify-region',
        effectsRow: '.fmcy-menu-effects-row',
        medicalRow: '.fmcy-menu-medical-row',
        strainRow: '.fmcy-menu-item-strain-title-row',
        imageLarge: '.fmcy-menu-item-thumb-image-large',
        columnContainer: '.fmcy-menu-column-container',
        magnifyButton: '.fmcy-menu-item-magnify-icon',
        fmcyMenuWrapper: '.fmcy-menu-wrapper',
        fmcyMenuContainer: '.fmcy-menu-container',
        fmcyInfoContainer: '.fmcy-menu-product-info-container',
        fmcyDescriptionText: '.fmcy-item-description-text-description',
        vendorIcon: '.fmcy-vendor-icon-region'
    },
    events: {
        'click @ui.btnClose': 'closeClicked',
        'mousemove @ui.imageContainer': 'magnifyImage'
    },
    regions: {
        pricesRegion: '.fmcy-item-prices-region',
        addToCartRegion: '.fmcy-item-add-to-cart-region',
        availableAtLocationsRegion: '.fmcy-available-at-locations-region',
        vendorIconRegion: '.fmcy-vendor-icon-region',
        favouriteButtonRegion: '.fmcy-favourite-button-region',
        tagBarRegion: '.fmcy-tag-bar-region',
        imageRegion: '.fmcy-menu-item-image-region',
        imageLargeRegion: '.fmcy-menu-item-large-image-region',
        videosGroupRegion: '.fmcy-item-videos-group-region',
        thumbnailSelectorRegion: '.fmcy-menu-item-thumb-selector-region',
        potencyRegion: '.fmcy-potency-region'
    },
    initialize: function(options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                customClassName: '',
                onlinePurchaseEnabled: false,
                showProductLocations: false,
                imagePreloading: true,
                filterLocation: null,
                shouldRenderProductLocations: this._shouldRenderProductLocations(),
            }
        );
        if (self.options.imagePreloading) {
            var createjs = require('preload-js');
            createjs.LoadQueue.loadTimeout = self.options.imagePreloadTimeout;
            self._preloadQueue = new createjs.LoadQueue(false);
        }
    },
    serializeData: function() {
        var nameIconColumnsHtml = '';
        var strain = this.model.get('strain');
        if (strain) {
          strain = strain.toUpperCase();
        }

        var nameContainsStrainName = false;
        if (this.model.get('itemName').toUpperCase().indexOf(strain) !== -1) {
          nameContainsStrainName = true;
          // hide strain if the strain name is alread within the title...
          strain = false;
        }

        return {
            itemName: this.model.get('itemName'),
            itemDescription:
                this.model.get('itemDescriptionHtml') ||
                this.model.get('itemDescription') ||
                '',
            strain: this.model.getStrainGroupCode() || '',
            rating: this.model.get('rating') || 0,
            mode: this.options.mode,
            effectsAttrs: this.getEffectsAttrsString(),
            medicalAttrs: this.getMedicalAttrsString(),
            strainTitleImgClass: this.getStrainTitleImageClassName(),
            bannerClassName: this.getBannerClassName(),
            onSale: this.model.isOnSale(),
            productLabResults: this.model.get('lab_results'),
            strainName: strain,
            onlinePurchaseEnabled: this.options.onlinePurchaseEnabled,
            isNew: this.model.get('is_new') === true,
            shouldRenderProductLocations: this.options.shouldRenderProductLocations,
            hasVideos: this.model.get('videos').length > 0
        };
    },
    _renderPotency: function () {
      this.potencyRegion.show(
          new PotencyDisplay({
            model: this.model,
            filterLocation: this.options.filterLocation
          })
      );
    },
    _renderPhotoSwiper: function () {
      var self = this;
      this._photoSwiper = new PhotoSwiper({
        collection: this.model.get('images')
      });

      this._photoSwiper.on('photo:swiper:slide:change', function (model) {
        self._setImagePrimary(model);
      });

      this.showChildView('imageRegion', this._photoSwiper);
    },
    _renderPrices: function() {
        if (this.options.mode === 'kiosk') {
          this._menuItemPrices = new MenuItemPrices({
              menuItemModel: this.model,
              collection: this.model.get('variants'),
              size: 'large',
              displayAddToCarToolTip: true,
              onSale: this.model.isOnSale(),
              hideOutOfStockVariation: true,
              filterLocation: this.options.appChannel.request('get:filter:location'),
              appChannel: this.options.appChannel,
              onlinePurchaseEnabled: this.options.onlinePurchaseEnabled,
              menuItemPriceLayoutSinglePrice: 'promotion',
              align: 'left'
          });
        } else {
          this._menuItemPrices = new MenuItemPricesLocationTable({
              menuItemModel: this.model,
              variantCollection: this.model.get('variants'),
              locations: this._getProductLocations(true),
              size: 'large',
              hideOutOfStockVariation: false,
              filterLocation: this.options.filterLocation,
              onSale: this.model.isOnSale(),
              appChannel: this.options.appChannel,
              menuItemPriceLayoutSinglePrice: 'stacked',
              align: 'left'
          });
        }
        this.showChildView('pricesRegion', this._menuItemPrices);
    },
    _maybeRenderVideos: function () {
      if (this.model.get('videos').length > 0) {
        this.videosGroup = new VideosGroup({
          videos: this.model.get('videos'),
          appChannel: this.options.appChannel
        });
        this.videosGroupRegion.show(this.videosGroup);
      }
    },
    _setImagePrimary: function (model) {
      this.model.get('images').each(function (image) {
        if (parseInt(image.get('id')) !== parseInt(model.get('id'))) {
          image.set('is_primary', '0');
        } else {
          image.set('is_primary', '1');
        }
      });
    },
    _maybeRenderImageThumbnails: function () {
      var self = this;
      if (this.model.get('images').length > 1) {
        this.thumbnailSelector = new ThumbnailSelector({
          collection: this.model.get('images'),
          appChannel: this.options.appChannel
        });
        this.thumbnailSelector.on('thumb:clicked', function (model) {
          self._setImagePrimary(model);
          self._maybeRenderImage();
        });
        this.thumbnailSelectorRegion.show(this.thumbnailSelector);
      }
    },
    _maybeRenderImage: function () {
      var
          self = this,
          zoomEnabled,
          imageSize
      ;
      if (UIUtils.isPhone()) {
          zoomEnabled = false;
          imageSize = 'medium';
      } else {
          zoomEnabled = true;
          imageSize = 'large';
      }

      function setImage (imageURL) {
          self.ui.itemImage.css(
              'background-image',
              'url(' +imageURL + ')'
          );
      }

      function hideImage () {
          self.ui.itemImage.css(
              'background-image',
              'none'
          );
      }

      if (zoomEnabled) {
        self.ui.itemImage.on('click', function () {
          self.options.appChannel.request(
              'load:product:zoomer',
              self.model
          );
        });
      }

      self.ui.magnifyButton.on('click', function () {
        self.options.appChannel.request(
            'load:product:zoomer',
            self.model
        );
      });

      var displayImageURL;

      displayImageURL = self.model.getProductImageURL(imageSize);

      if (!displayImageURL) {
          displayImageURL = self.options.noImageAvailableIcon;
      }

      if (self.options.imagePreloading) {

          self.imageRegion.show(
              new (require('treeline-shared-components/spinner'))({
                  message: ''
              })
          );

          self.imageLargeRegion.show(
              new (require('treeline-shared-components/spinner'))({
                  message: ''
              })
          );
          hideImage();

          var handleFileLoadError = function (event) {
              if (!self.isRendered) {
                  return false;
              }
              if (event.item.id === self.model.id) {
                  console.log('File load error occurred: ', event);
                  self._preloadQueue.removeAllEventListeners('fileload');
                  self._preloadQueue.removeAllEventListeners('error');
                  self.imageRegion.empty();
                  self.imageLargeRegion.empty();
                  setImage(self.options.noImageAvailableIcon);
              }
          };

          var handleFileLoaded = function(event) {
              if (!self.isRendered) {
                  return false;
              }
              if (event.item.id === self.model.id) {
                  self._preloadQueue.removeAllEventListeners('fileload');
                  self._preloadQueue.removeAllEventListeners('error');
                  self.imageRegion.empty();
                  self.imageLargeRegion.empty();
                  if((UIUtils.isPhone() || UIUtils.isTablet() || UIUtils.isAccessoriesKioskWidth()) && self.model.get('images').length > 1) {
                    self._renderPhotoSwiper();
                  } else {
                    setImage(event.item.src);
                  }
              }
          };

          self._preloadQueue.on('error', handleFileLoadError);
          self._preloadQueue.on('fileload', handleFileLoaded);
          self._preloadQueue.loadFile({
              id: self.model.id,
              src: displayImageURL
          });

      } else {
          setImage(displayImageURL);
      }
    },
    _maybeRenderFavouriteButton: function () {
      var self = this;
      if ((this.options.mode == 'menu' && this.options.isUserLoggedIn) || (this.options.mode == 'embedded' && this.options.isUserLoggedIn)) {
        self.options.appChannel.request('is:favourite', self.model).then(function (response) {
          var favouriteButton = new FavouriteButton({
            isFavourite: response
          });
          favouriteButton.on('toggle:favourite', function (isFavourite) {
            self.model.set('isFavourite', isFavourite);
            self.options.appChannel.request('toggle:favourite', self.model, isFavourite).then(function (response) {
            });
          });
          self.favouriteButtonRegion.show(favouriteButton);
        });
      }
    },
    onRender: function() {
        var self = this;
        if (!self.model.getStrainGroupCode()) {
            self.ui.strainAttribute.css({ display: 'none' });
        }

        if (self.model.isOrganic()) {
          self.$el.addClass('fmcy-product-is-organic');
        }

        if (self.model.isBCGrown()) {
          self.$el.addClass('fmcy-product-is-bc-grown');
        }

        if (self.model.isFarmExclusive()) {
          self.$el.addClass('fmcy-product-is-farm-exclusive');
        }

        if (this.options.mode) {
          self.$el.addClass('fmcy-product-expanded-mode-' + this.options.mode);
        }
        if (self.model.isVegan()) {
          self.$el.addClass('fmcy-product-is-vegan');
        }

        if (self.model.isHighCBD()) {
          self.$el.addClass('fmcy-product-high-cbd');
        }

        if (self.model.isHighCBNCBG()) {
          self.$el.addClass('fmcy-product-high-cbn-cbg');
        }

        var strain = self.model.getStrainGroupCode();
        if (strain) {
            self.$el.addClass(strain);
        }

        if (!self.model.get('rating') || self.model.get('rating') === '0') {
            self.ui.ratingAttribute.css({ display: 'none' });
        }
        self.$el.css({ 'min-height': $(window).height() + 'px' });

        self.$el.addClass(self.options.customClassName);

        if (self.model.get('theme') === 'dark') {
          self.$el.addClass('fmcy-product-tile-theme-dark');
        }

        var vendor = this.model.get('vendor');
        if (vendor) {
          var brandIcon = new (require('../product-tile/image-display'))({
            imageURL: vendor.get('image_medium_url_' + this.model.get('theme') + '_theme'),
            displayNoImageAvailableIcon: false
          });

          brandIcon.$el.addClass('fmcy-vendor-icon');
          this.vendorIconRegion.show(brandIcon);
        }

        self._renderPrices();
        self._maybeRenderImage();
        self._maybeRenderAvailableAtLocations();
        self._maybeRenderVideos();
        self._maybeRenderImageThumbnails();
        self._renderPotency();
        self._maybeRenderFavouriteButton();
        self.ui.effectsRow.hide();
        self.ui.medicalRow.hide();
        self.ui.strainRow.hide();


        if (this._shouldRenderTagBar()) {
          this.$el.addClass('fmcy-product-tile-showing-tag-bar');
          this.tagBarRegion.show(
            new (require('../product-tile/tag-bar'))({
              showOnSaleTag: this.model.isOnSale(),
              showOnClearanceTag: this.model.isOnClearance(),
              productTagText: this._getProductTag(),
              showCBDTag: this.model.isHighCBD(),
              showCBNCBGTag: this.model.isHighCBNCBG(),
              showBcGrownTag: this.model.isBCGrown(),
              showFarmExclusiveTag: this.model.isFarmExclusive(),
              showOrganicTag: this.model.isOrganic(),
              showVeganTag: this.model.isVegan()
            })
          );
        }

        BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onShow: function () {
      this._onWindowResize();
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
    },
    _shouldRenderTagBar: function () {
      return this.model.isOnSale() || this.model.isOnClearance() || this.model.isOrganic() || this.model.isBCGrown() || this.model.isFarmExclusive() || this.model.isVegan() || this.model.isHighCBD() || this.model.isHighCBNCBG() || this._getProductTag();
    },
    _getProductTag: function () {
      var strainGroup = this.model.getStrainGroupCode();
      if (this.options.productTag) {
        return this.options.productTag;
      } else if (this.model.get('promotion_headline') && !this.model.isOnClearance() && this.model.get('promotion_headline').toLowerCase() !== 'clearance' && this.model.get('promotion_headline').toLowerCase() !== 'weekly') {
        return this.model.get('promotion_headline');
      } else if (strainGroup) {
          return strainGroup;
      } else {
          var productTag = '';
          var categorySlug;
          var x = 0;
          var categories = this.model.get('categories');
          var categoriesArr;
          if (categories instanceof Backbone.Collection) {
            categoriesArr = categories.toJSON();
          } else {
            categoriesArr = categories;
          }
          while (x <= this._DISPLAY_PRODUCT_TAG_FOR_CATEGORIES.length - 1 && !productTag) {
              categorySlug = this._DISPLAY_PRODUCT_TAG_FOR_CATEGORIES[x];
              if (_.findWhere(categoriesArr, { slug: categorySlug })) {
                  productTag = categorySlug;
              }
              x++;
          }
          return productTag;
      }
    },
    _maybeRenderAvailableAtLocations: function () {
        if (!this.options.shouldRenderProductLocations) {
            return;
        }

        this.availableAtLocationsRegion.show(
            new AvailableAtLocations({
                collection: this._getProductLocations(),
                align: 'left'
            })
        );
    },
    closeClicked: function() {
        var self = this;
        if (this.addToCartBarView && this.addToCartBarView.$el) {
            this.addToCartBarView.hide();
        }
        self.trigger('close:clicked');
    },
    _onWindowResize: function (event) {

      var bottomBuffer = 200;
      this.ui.imageLarge.height($(window).height() - bottomBuffer);
      this.ui.imageLarge.width($(window).width() / 2);
      this.ui.imageLarge.css(
          'right',
          0
      );
      //990
      if ($(window).width() >= 1081) {
        this.ui.fmcyInfoContainer.css('min-height', (this.ui.imageLarge.height() - this.ui.vendorIcon.height()) + 100);
      }

      if (this.model.get('videos').length === 0) {
        this.ui.fmcyMenuWrapper.height(this.ui.fmcyInfoContainer.height() + this.ui.itemImage.height() + bottomBuffer);
      }
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
    }
});
_.extend(MenuItemExpanded.prototype, require('./common/menu-item-mixin'));
module.exports = MenuItemExpanded;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-item-expanded.js
 **/